import {ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ApplicationService} from './services/application.service';
import {UserService} from './services/user.service';
import {SessionGuard} from './guards/session.guard';
import {LoggedInGuard} from './guards/logged-in.guard';
import {AppInterceptor} from './interceptors/app-interceptor';
import {SellerService} from './services/seller.service';
import {MessagingService} from './services/messaging.service';
import {TicketService} from './services/ticket.service';
import {OrderService} from './services/order.service';
import {MarketplaceService} from './services/marketplace.service';
import {CatalogService} from './services/catalog.service';
import {FileService} from './services/file.service';
import {OrganizationService} from './services/organization.service';
import {LocationService} from './services/location.service';
import {DepartmentService} from './services/department.service';
import {DesignationService} from './services/designation.service';
import {ProjectService} from './services/project.service';
import {EntityService} from './services/entity.service';
import {SurveyService} from './services/survey.service';
import {ContentService} from './services/content.service';
import {MasterDataService} from './services/master-data.service';
import {CustomerService} from './services/customer.service';
import {DistributionService} from './services/distribution.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule, HttpClientModule
  ]
})
export class ProvidersModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ProvidersModule,
      providers: [
        ApplicationService,
        CatalogService,
        FileService,
        UserService,
        SellerService,
        MessagingService,
        TicketService,
        OrderService,
        OrganizationService,
        MarketplaceService,
        LocationService,
        DepartmentService,
        DesignationService,
        ProjectService,
        EntityService,
        ContentService,
        SurveyService,
        SessionGuard,
        LoggedInGuard,
        MasterDataService,
        CustomerService,
        DistributionService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AppInterceptor,
          multi: true
        }
      ]
    };
  }

  static forChild(): ModuleWithProviders {
    return {
      ngModule: ProvidersModule
    };
  }
}
